import React, { useState, useEffect } from 'react';
import { logo } from '../../../assets';
import { useNavigate } from 'react-router-dom';
import axios from '../../../library/axios';
import { getModule, setHrefWithSlugHook, useNavigateWithSlugHook, } from "../../../../src/config/routes/guards/slug";
import { getSlug, } from "../../../../src/config/routes/guards/slug";

const NavbarComp = () => {
  const [namaLengkap, setnamaLengkap] = useState('');
  const [currentUrl, setCurrentUrl] = useState('');
  const [menuGeneral, setmenuGeneral] = useState([]);
  const [menuMaster, setmenuMaster] = useState([]);
  const [menuMasterRisk, setmenuMasterRisk] = useState([]);
  const [menuTransactions, setmenuTransactions] = useState([]);

  const navigate = useNavigateWithSlugHook();
  const logout = async () => {
    setCurrentUrl("/logout");
    try {
      const token = localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`);
      if (token) {
        await axios({
          url: '/users/logout',
          method: 'POST',
          headers: {
            'Access-Control-Allow-Origin': '*',
            Authorization: `Bearer ${token}`,
          },
        });
      }
    } catch (err) {
      console.log('Logout error:', err);
    } finally {
      localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
      setHrefWithSlugHook('/login');
    }
  };
  const handleChangePage = (path) => {
    setCurrentUrl(path);
    navigate(path);
  };

  const fetchData = async () => {
    try {
      const options = {
        url: `/users/detailUser`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data?.data);
      setnamaLengkap(data?.data?.namaLengkap);
      setmenuGeneral([]);
      setmenuMaster([]);
      setmenuMasterRisk([]);
      setmenuTransactions([]);
      for (
        let i = 0;
        i <
        data?.data?.mapping_user_groups[0]?.group?.mapping_module_groups.length;
        i++
      ) {
        if (
          data?.data?.mapping_user_groups[0]?.group?.mapping_module_groups[i]
            ?.module?.pathModule === '/accreditation' ||
          data?.data?.mapping_user_groups[0]?.group?.mapping_module_groups[i]
            ?.module?.pathModule === '/documents'
        ) {
          setmenuTransactions((menuTransactions) => [
            ...menuTransactions,
            {
              label:
                data.data.mapping_user_groups[0].group.mapping_module_groups[i]
                  .module.namaModule,
              path: data.data.mapping_user_groups[0].group
                .mapping_module_groups[i].module.pathModule,
            },
          ]);
        } else if (
          // data.data.mapping_user_groups[i].module.pathModule === '/logout' ||
          // data.data.mapping_user_groups[i].module.pathModule === '/dashboard-external' ||
          data?.data?.mapping_user_groups[0]?.group?.mapping_module_groups[i]
            ?.module?.pathModule === '/dashboard-pokja' ||
          data?.data?.mapping_user_groups[0]?.group?.mapping_module_groups[i]
            ?.module?.pathModule === '/dashboard-internal'
        ) {
          setmenuGeneral((menuGeneral) => [
            ...menuGeneral,
            {
              label:
                data.data.mapping_user_groups[0].group.mapping_module_groups[i]
                  .module.namaModule,
              path: data.data.mapping_user_groups[0].group
                .mapping_module_groups[i].module.pathModule,
            },
          ]);
        } else if (
          data?.data?.mapping_user_groups[0]?.group?.mapping_module_groups[i]
            ?.module?.pathModule === '/users' ||
          data?.data?.mapping_user_groups[0]?.group?.mapping_module_groups[i]
            ?.module?.pathModule === '/profile' ||
          data?.data?.mapping_user_groups[0]?.group?.mapping_module_groups[i]
            ?.module?.pathModule === '/standards-accreditation' ||
          data?.data?.mapping_user_groups[0]?.group?.mapping_module_groups[i]
            ?.module?.pathModule === '/chapters-accreditation' ||
          data?.data?.mapping_user_groups[0]?.group?.mapping_module_groups[i]
            ?.module?.pathModule === '/elements-accreditation' ||
          data?.data?.mapping_user_groups[0]?.group?.mapping_module_groups[i]
            ?.module?.pathModule === '/variables-accreditation' ||
          data?.data?.mapping_user_groups[0]?.group?.mapping_module_groups[i]
            ?.module?.pathModule === '/risk-divisions'
        ) {
          setmenuMaster((menuMaster) => [
            ...menuMaster,
            {
              label:
                data?.data?.mapping_user_groups[0]?.group
                  ?.mapping_module_groups[i]?.module?.namaModule,
              path: data?.data?.mapping_user_groups[0]?.group
                ?.mapping_module_groups[i]?.module?.pathModule,
            },
          ]);
        } else if (
          data?.data?.mapping_user_groups[0]?.group?.mapping_module_groups[i]
            ?.module?.pathModule === '/risk-activity-targets' ||
          data?.data?.mapping_user_groups[0]?.group?.mapping_module_groups[i]
            ?.module?.pathModule === '/risk-heatmap'
        ) {
          setmenuMasterRisk((menuMasterRisk) => [
            ...menuMasterRisk,
            {
              label:
                data?.data?.mapping_user_groups[0]?.group
                  ?.mapping_module_groups[i]?.module?.namaModule,
              path: data?.data?.mapping_user_groups[0]?.group
                ?.mapping_module_groups[i]?.module?.pathModule,
            },
          ]);
        }
      }
      // console.log(data)
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // console.log(menuMasterRisk);

  return (
    <>
      {/*begin::Aside*/}
      <div
        style={{ background: 'linear-gradient(#3498DB, #5DADE2)' }}
        id="kt_aside"
        className="aside"
        data-kt-drawer="true"
        data-kt-drawer-name="aside"
        data-kt-drawer-activate="{default: true, lg: false}"
        data-kt-drawer-overlay="true"
        data-kt-drawer-width="{default:'200px', '300px': '250px'}"
        data-kt-drawer-direction="start"
        data-kt-drawer-toggle="#kt_aside_mobile_toggle"
      >
        {/*begin::Brand*/}
        <div
          style={{ backgroundColor: 'white' }}
          className="aside-logo flex-column-auto"
          id="kt_aside_logo"
        >
          {/*begin::Logo*/}
          <a href="../../demo1/dist/index.html">
            <img alt="Logo" src={logo} className="h-40px logo" />
          </a>
          {/*end::Logo*/}
        </div>
        {/*end::Brand*/}
        {/*begin::Aside menu*/}
        <div className="aside-menu flex-column-fluid">
          <div className="hover-scroll-y h-550px px-5">
            {/*begin::Aside Menu*/}
            <div
              className="hover-scroll-overlay-y my-5 my-lg-5"
              id="kt_aside_menu_wrapper"
              data-kt-scroll="true"
              data-kt-scroll-activate="{default: false, lg: true}"
              data-kt-scroll-height="auto"
              data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer"
              data-kt-scroll-wrappers="#kt_aside_menu"
              data-kt-scroll-offset={0}
            >
              {/*begin::Menu*/}

              <div
                className="menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500 mb-3"
                id="#kt_aside_menu"
                data-kt-menu="true"
              >
                <div className="menu-item">
                  <div className="menu-content pb-2">
                    <span
                      style={{ fontWeight: 'bold' }}
                      className="menu-section text-white fs-7 ls-1"
                    >
                      Halo, <br></br>
                      {namaLengkap}
                    </span>
                  </div>
                </div>
              </div>

              <div
                className="menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500"
                id="#kt_aside_menu"
                data-kt-menu="true"
              >
                <div className="menu-item">
                  <div className="menu-content pb-2">
                    <span
                      style={{ fontWeight: 'bold', fontStyle: 'italic' }}
                      className="menu-section text-warning text-uppercase fs-7 ls-1"
                    >
                      UMUM
                    </span>
                  </div>
                </div>
                <div className="menu-item">
                  <a
                    className="menu-link"
                    onClick={() => logout()}
                  >
                    <span
                      className="menu-title"
                      style={{
                        fontWeight: '500',
                        color: currentUrl === `/logout` ? 'black' : 'white',
                      }}
                    >
                      Logout
                    </span>
                  </a>
                </div>
                {menuGeneral.map((row, i) => (
                  <div key={i} className="menu-item">
                    <a
                      className="menu-link"
                      onClick={() => handleChangePage(`${row.path}`)}
                    >
                      <span
                        className="menu-title"
                        style={{
                          fontWeight: '500',
                          color:
                            currentUrl === `${row.path}` ? 'black' : 'white',
                        }}
                      >
                        {row.label}
                      </span>
                    </a>
                  </div>
                ))}
              </div>

              {menuMaster.length > 0 ? (
                <>
                  <div
                    className="menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500"
                    id="#kt_aside_menu"
                    data-kt-menu="true"
                  >
                    <div className="menu-item">
                      <div className="menu-content pb-2">
                        <span
                          style={{ fontWeight: 'bold', fontStyle: 'italic' }}
                          className="menu-section text-warning text-uppercase fs-7 ls-1"
                        >
                          DATA MASTER
                        </span>
                      </div>
                    </div>
                    {menuMaster.map((row, i) => (
                      <div key={i} className="menu-item">
                        <a
                          className="menu-link"
                          onClick={() => handleChangePage(`${row.path}`)}
                        >
                          <span
                            className="menu-title"
                            style={{
                              fontWeight: '500',
                              color:
                                currentUrl === `${row.path}`
                                  ? 'black'
                                  : 'white',
                            }}
                          >
                            {row.label}
                          </span>
                        </a>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                ''
              )}

              {menuTransactions.length > 0 ? (
                <>
                  <div
                    className="menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500"
                    id="#kt_aside_menu"
                    data-kt-menu="true"
                  >
                    <div className="menu-item">
                      <div className="menu-content pb-2">
                        <span
                          style={{ fontWeight: 'bold', fontStyle: 'italic' }}
                          className="menu-section text-warning fs-7 ls-1"
                        >
                          DATA TRANSAKSI
                        </span>
                      </div>
                    </div>
                    {menuTransactions.map((row, i) => (
                      <div key={i} className="menu-item">
                        <a
                          className="menu-link"
                          onClick={() => handleChangePage(`${row.path}`)}
                        >
                          <span
                            className="menu-title"
                            style={{
                              fontWeight: '500',
                              color:
                                currentUrl === `${row.path}`
                                  ? 'black'
                                  : 'white',
                            }}
                          >
                            {row.label}
                          </span>
                        </a>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                ''
              )}

              {menuMasterRisk.length > 0 ? (
                <>
                  <div
                    className="menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500"
                    id="#kt_aside_menu"
                    data-kt-menu="true"
                  >
                    <div className="menu-item">
                      <div className="menu-content pb-2">
                        <span
                          style={{ fontWeight: 'bold', fontStyle: 'italic' }}
                          className="menu-section text-warning text-uppercase fs-7 ls-1"
                        >
                          RISK MANAGEMENT
                        </span>
                      </div>
                    </div>
                    {menuMasterRisk.map((row, i) => (
                      <div key={i} className="menu-item">
                        <a
                          className="menu-link"
                          onClick={() => handleChangePage(`${row.path}`)}
                        >
                          <span
                            className="menu-title"
                            style={{
                              fontWeight: '500',
                              color:
                                currentUrl === `${row.path}`
                                  ? 'black'
                                  : 'white',
                            }}
                          >
                            {row.label}
                          </span>
                        </a>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                ''
              )}

              {/*end::Menu*/}
            </div>
            {/*end::Aside Menu*/}
          </div>
        </div>
        {/*end::Aside menu*/}
        {/*begin::Footer*/}
        <div
          className="aside-footer flex-column-auto pt-5 pb-7 px-5"
          id="kt_aside_footer"
        >
          <a
            href="https://lam-kprs.id/"
            target="_blank"
            className="btn btn-custom btn-success w-100"
            data-bs-toggle="tooltip"
            data-bs-trigger="hover"
            data-bs-dismiss-="click"
            title="Made with love by TIKOM LAM-KPRS"
          >
            <span className="btn-label">2025© | LAM-KPRS</span>
            {/*begin::Svg Icon | path: icons/duotune/general/gen005.svg*/}
            <span className="svg-icon btn-icon svg-icon-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  opacity="0.3"
                  d="M19 22H5C4.4 22 4 21.6 4 21V3C4 2.4 4.4 2 5 2H14L20 8V21C20 21.6 19.6 22 19 22ZM15 17C15 16.4 14.6 16 14 16H8C7.4 16 7 16.4 7 17C7 17.6 7.4 18 8 18H14C14.6 18 15 17.6 15 17ZM17 12C17 11.4 16.6 11 16 11H8C7.4 11 7 11.4 7 12C7 12.6 7.4 13 8 13H16C16.6 13 17 12.6 17 12ZM17 7C17 6.4 16.6 6 16 6H8C7.4 6 7 6.4 7 7C7 7.6 7.4 8 8 8H16C16.6 8 17 7.6 17 7Z"
                  fill="black"
                />
                <path d="M15 8H20L14 2V7C14 7.6 14.4 8 15 8Z" fill="black" />
              </svg>
            </span>
            {/*end::Svg Icon*/}
          </a>
        </div>
        {/*end::Footer*/}
      </div>
      {/*end::Aside*/}
    </>
  );
};

export default NavbarComp;
